import React from 'react';
import { motion } from 'framer-motion';

const Logo = ({ darkMode }) => {
  const svgVariants = {
    hover: {
      scale: 1.04,
      transition: { duration: 0.3, ease: 'easeOut' },
    },
  };
  const pathVariants = {
    hover: {
      scale: 1.06,
      transition: { duration: 0.4, ease: 'easeOut' },
    },
  };
  const textVariants = {
    hover: {
      y: [-1, 1, -1],
      transition: { duration: 2, ease: 'easeInOut', repeat: Infinity, repeatType: 'mirror' },
    },
  };

  return (
    <motion.div
      className="flex items-center space-x-2"
      whileHover="hover"
      initial="initial"
      style={{ minHeight: 40 }}
    >
      <motion.svg
        className="h-8 w-8 flex-shrink-0"
        viewBox="0 0 32 32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        variants={svgVariants}
      >
        <defs>
          <linearGradient id="logo-chain-gradient" x1="0" y1="0" x2="32" y2="32" gradientUnits="userSpaceOnUse">
            <stop stopColor={darkMode ? '#60a5fa' : '#2563eb'} />
            <stop offset="1" stopColor={darkMode ? '#a855f7' : '#7c3aed'} />
          </linearGradient>
          <linearGradient id="logo-chain-gold" x1="0" y1="0" x2="32" y2="32" gradientUnits="userSpaceOnUse">
            <stop stopColor="#fbbf24" />
            <stop offset="1" stopColor="#f59e0b" />
          </linearGradient>
        </defs>
        <motion.ellipse
          cx="11"
          cy="16"
          rx="7"
          ry="9"
          stroke="url(#logo-chain-gradient)"
          strokeWidth="3"
          fill="none"
          variants={pathVariants}
        />
        <motion.ellipse
          cx="21"
          cy="16"
          rx="7"
          ry="9"
          stroke="url(#logo-chain-gradient)"
          strokeWidth="3"
          fill="none"
          variants={pathVariants}
        />
        <motion.path
          d="M8 24 L16 28 L24 24"
          stroke="url(#logo-chain-gold)"
          strokeWidth="2.2"
          fill="none"
          strokeLinecap="round"
          strokeLinejoin="round"
          variants={pathVariants}
        />
        <motion.circle cx="16" cy="27" r="1.5" fill="#fbbf24" variants={pathVariants} />
      </motion.svg>
      <motion.div
        className={`flex flex-col leading-tight ${darkMode ? 'text-white' : 'text-slate-900'}`}
        variants={textVariants}
        style={{ lineHeight: 1 }}
      >
        <motion.div className="flex items-baseline">
          <span
            className={`font-display text-lg font-semibold tracking-tight ${darkMode ? 'text-white' : 'text-slate-900'}`}
            style={{ letterSpacing: '0.01em' }}
          >
            Onchainvest
          </span>
          <span
            className={`font-display text-lg font-light tracking-tight ml-1 ${darkMode ? 'text-blue-300' : 'text-blue-600'}`}
            style={{ letterSpacing: '0.01em' }}
          >
            Capital
          </span>
        </motion.div>
      </motion.div>
    </motion.div>
  );
};

export default Logo;
